import { getCtaConfig } from "~/lib/constants/navbar";
import * as m from "~/paraglide/messages.js";

/**
 * The opening statement. Centred, and deliberately without an image: the proof
 * is the workbench directly below it, not a photograph beside it.
 *
 * The `wide` class on the line breaks is the design's own — it drops the
 * hard-wrapped lede back to natural wrapping on narrow viewports.
 */
export function Hero() {
  const cta = getCtaConfig();

  return (
    <section className="hero wrap">
      <p className="intro-line">{m.home_intro_line()}</p>

      <h1>
        {m.home_hero_title_1()}
        <br /> {m.home_hero_title_2()}
      </h1>

      <p className="hero-lede">
        {m.home_hero_lede_1()}
        <br className="wide" /> {m.home_hero_lede_2()}
        <br className="wide" /> {m.home_hero_lede_3()}
      </p>

      <div className="hero-actions">
        <a
          className="button button-solid"
          href={cta.href}
          rel="noopener"
          target="_blank"
        >
          {m.home_hero_cta_call()} <span aria-hidden="true">↗</span>
        </a>
        <a className="button button-outline" href="#capabilities">
          {m.home_hero_cta_work()} <span aria-hidden="true">↓</span>
        </a>
      </div>

      <p className="hero-note">{m.home_hero_note()}</p>
    </section>
  );
}
